<template>
  <img
    class="CoreImage"
    :src="src"
    v-bind="$attrs"
    loading="lazy"
    @error="onImageError"
  />
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { useConfig } from '../config'
import { useTracker } from '/@/core/tracking/api'
import { getUrlDomain, truncateUrl } from '/@/utils/misc'

const config = useConfig()

const props = defineProps<{
  src: string
}>()

onMounted(() => {
  if (props.src.startsWith('/@') && config.env !== 'prod') {
    alert(
      `Invalid src url passed with @. Use an import to resolve the path before passing it as a prop to CoreImage. I.e. import myImg from '/@/assets/myImg.png'.`,
    )
  }
})

const tracker = useTracker()

function onImageError() {
  tracker.send('Image Load Failed', {
    component: 'Core Image',
    urlDomain: getUrlDomain(props.src),
    url: truncateUrl(props.src),
  })
}
</script>

<style scoped></style>
